var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-menu"},[_c('div',{staticClass:"container grid-list-md pa-0 fill-height"},[_c('div',{staticClass:"layout row wrap ma-0 align-center justify-center"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }